// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

type Props = {
  visible: boolean;
  disabled: boolean;
  hideOnDisabled?: boolean;
  onToggle: (visible: boolean) => void;
};

export const VisibilityToggle = ({ visible, disabled, hideOnDisabled = true, onToggle }: Props) =>
  disabled && hideOnDisabled ? null : (
    <ActionIcon
      size="sm"
      className={`visibility-toggle ${visible ? '' : 'inactive'}`}
      onClick={(e) => {
        if (!disabled) {
          onToggle(!visible);
          e.stopPropagation();
        }
      }}
      component="div"
      disabled={disabled}
      bg={disabled ? 'transparent' : undefined}
      style={{
        cursor: disabled ? 'initial' : 'pointer',
      }}
    >
      <EvolveIcon icon={visible ? 'Visible' : 'Hidden'} color={disabled ? 'gray' : 'black'} />
    </ActionIcon>
  );
